<template>
  <LeadForm v-if="visitorHasSelectedSales" class="LeadFormOption" v-bind="{ segment, whenSubmitted }" />
  <ChooseRequestType v-else v-bind="{ selectSales, hidePopup }"/>
</template>

<script>
import ChooseRequestType from './form/ChooseRequestType.vue'
import LeadForm from './form/LeadForm.vue'

export default {
  components: {
    ChooseRequestType,
    LeadForm,
  },
  data() {
    return {
      visitorHasSelectedSales: false,
    }
  },
  props: {
    segment: String,
    whenSubmitted: Function,
    hidePopup: Function,
  },
  methods: {
    selectSales() {
      this.visitorHasSelectedSales = true
    }
  },
}
</script>
